import React, { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyCd611dvEPyn688bB6hF_Ul9-iErla70Gw",
    authDomain: "my-portfolio-cb7be.firebaseapp.com",
    projectId: "my-portfolio-cb7be",
    storageBucket: "my-portfolio-cb7be.appspot.com",
    messagingSenderId: "854943335774",
    appId: "1:854943335774:web:d36b6aa3d7375a2c743bcf",
    measurementId: "G-GE9XVWWELZ"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

const UploadCertificate = () => {
    const [image, setImage] = useState(null);
    const [imageUrl, setImageUrl] = useState('');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [user, setUser] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
          if (user) {
            setUser(user);
          } else {
            setUser(null);
          }
        });
    
        return () => unsubscribe();
      }, []);

      const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.size > 10485760) { // 10MB limit
          setError("File size exceeds 10MB");
          return;
        }
        setImage(file);
        setError('');
      };

    const handleUpload = async () => {
        try {
            if (!image || !title || !description) {
                console.error("All fields are required");
                return;
            }

            if (!user) {
                setError("User is not authenticated");
                return;
              }

            const storageRef = ref(storage, `certificates/${image.name}`);
            await uploadBytes(storageRef, image);
            const url = await getDownloadURL(storageRef);
            setImageUrl(url);


            // Send data to backend
                const response = await fetch ('https://sirichandhanak-backend.vercel.app/api/uploadCertificate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    title,
                    description,
                    imageUrl: url,
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to send data to backend");
              }

            console.log("Image uploaded and data sent to backend successfully.");
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleSignIn = async () => {
        try {
          await signInWithPopup(auth, provider);
        } catch (error) {
          setError(`Sign-in failed: ${error.message}`);
        }
      };

    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-xl">
        <h2 className="text-2xl font-bold mb-4">Upload Image</h2>
        {error && <div className="text-red-500 mb-4">{error}</div>}
        {user ? (
          <>
        <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-xl">
            <h2 className="text-2xl font-bold mb-4">Upload Certificate</h2>
            <input type="file" onChange={handleFileChange} className="mb-4" />
            <input type="text" placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} className="block w-full border border-gray-300 rounded-md px-4 py-2 mt-4" />
            <textarea placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} className="block w-full border border-gray-300 rounded-md px-4 py-2 mt-4" />
            <button onClick={handleUpload} className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded">
                Upload Image
            </button>
            {imageUrl && <img src={imageUrl} alt="Uploaded Certificate" className="mt-4 rounded-lg" />}
        </div>
        </>
      ) : (
        <button onClick={handleSignIn} className="bg-green-500 hover:bg-green-600 text-white font-semibold px-4 py-2 rounded">
          Sign in with Google
        </button>
      )}
    </div>
    );
};

export default UploadCertificate;